import { Component, ElementRef, ViewChild } from '@angular/core';
import { Manco } from '../manco-to-check-up-on';

@Component({
  selector: 'app-manco-dialog',
  templateUrl: './manco-dialog.component.html',
  styleUrls: ['./manco-dialog.component.scss'],
})
export class MancoDialogComponent {
  @ViewChild('appDialog') dialog!: ElementRef<HTMLDialogElement>;

  theManco?: Manco;

  async showModal(manco: Manco): Promise<Manco | undefined> {
    this.theManco = {
      ...manco,
      note: manco.note ?? '',
      returnNumber: manco.returnNumber ?? '',
    }; // Create a copy of the data
    this.dialog.nativeElement.showModal();

    return new Promise(resolve => {
      this.dialog.nativeElement.addEventListener(
        'close',
        () => {
          resolve(this.dialog.nativeElement.returnValue === 'ok' ? this.theManco : undefined);
        },
        { once: true }
      );
    });
  }

  closeDialog(result: 'ok' | 'cancel') {
    this.dialog.nativeElement.returnValue = result;
    this.dialog.nativeElement.close(result);
  }

  handleSubmit(updatedData: Manco) {
    this.theManco = updatedData;
    this.closeDialog('ok');
  }
}
